import React, { PureComponent, Fragment } from 'react'
import { Table, Button, Select } from 'antd';
import CustomModal from '../../../../components/CustomModal/index'
import * as config from "../../../ProcessDesign/AlgorithmEditModalComponent/config"
import closeimg from '../../../../../resources/img/icon-close.png'
class step2detail1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showDataList: [],
        };
    }
    componentDidMount() {
        this.refs.step2detail.show();
        if (this.props.typeOfFast && this.props.typeOfFast === "typeOfFast") this.getAllPluginCount_Fast();
        else this.getAllPluginCount();
    }
    show = () => {
        this.refs.step2detail.show()
    }
    close = () => {
        this.props.closealgorithmdetails1()
        this.refs.step2detail.close()
    }
    render() {
        const { showDataList } = this.state;
        const { detailData, detailtitle, typeOfFast } = this.props;
        return (
            <Fragment>
                <CustomModal ref='step2detail' >
                    <div className='step2detailwindow'>
                        <div className='step2detailTitle modal-dragable'>
                            {typeOfFast && typeOfFast === "typeOfFast" ?
                                detailtitle && detailtitle
                                : detailData && detailData.name}
                            <img alt='' src={closeimg} className='modal-closeimg step2detailcloseimg' onClick={this.close}></img>
                        </div>
                    </div>
                    <div className='step2detailContent'>
                        {showDataList.map((sendData, index) => {
                            return (
                                <Fragment>
                                    <div className='step2detailContenttitle1'>算法名称</div>
                                    <div className='step2detailContenttext'>{sendData.name}</div>
                                    <div className='step2detailContenttext'>IWPHPI-2m8m_华科_1.0</div>
                                    <div className='step2detailContenttitle'>从属分类</div>
                                    <div className='step2detailContenttext'>水体类产品_水表反射率产品</div>
                                    <div className='step2detailContenttitle'>作者</div>
                                    <div className='step2detailContenttext'>华科</div>
                                    <div className='step2detailContenttitle'>版本</div>
                                    <div className='step2detailContenttext'>Version 1.0</div>
                                    <div className='step2detailContenttitle'>算法简介</div>
                                    <div className='step2detailContenttext'>{`${sendData.name}算法，具体考察${sendData.name}。`}</div>
                                    <div className='step2detailContenttitle'>算法参数</div>
                                    <div className='step2detailContent2'>
                                        {sendData.parameterDataList.map((parameterData, index2) => {
                                            return (
                                                <Fragment>
                                                    <div className='step2detailContent2_title'>{`参数类型${index2 + 1}：${parameterData.name}`}</div>
                                                    <div className='step2detailContent2_parameter'>
                                                        {parameterData.dataList.map((component, index3) => {
                                                            return <div className='step2detailContenttext' key={index3 + '-3'}>
                                                                {`算法参数${index2 + index3 + 1}：${component.name}`}
                                                            </div>
                                                        })}
                                                    </div>
                                                </Fragment>
                                            )
                                        })}
                                    </div>
                                </Fragment>
                            )
                        })}
                    </div>
                </CustomModal>
            </Fragment >
        );
    }

    //最开始只是作为检查数据是否全部输入，现在作为init初始化以及将数据对应传入后台中的必要函数。
    getAllPluginCount = () => {
        const { detailData } = this.props;
        let count = 0;
        let showDataList = [];
        let sendData = { name: detailData && detailData.name, parameterDataList: [] };
        let componentList = config.returnComponentByName(detailData && detailData.name)
        componentList.map((data) => {
            let parameterDataList = [];
            data.componentList.map((component) => {
                parameterDataList.push({ name: component.type, parameterData: "" });
                count += 1;
            })
            sendData.parameterDataList.push({ name: data.type, dataList: [...parameterDataList] });
        })
        showDataList.push(sendData);
        this.setState({ allPluginCount: count, showDataList: [...showDataList] });
    }

    getAllPluginCount_Fast = () => {
        const { detailtitle } = this.props;
        let count = 0;
        let showDataList = [];
        let sendData = { name: detailtitle, parameterDataList: [] };
        let componentList = config.returnComponentByName(detailtitle)
        componentList.map((data) => {
            let parameterDataList = [];
            data.componentList.map((component) => {
                parameterDataList.push({ name: component.type, parameterData: "" });
                count += 1;
            })
            sendData.parameterDataList.push({ name: data.type, dataList: [...parameterDataList] });
        })
        showDataList.push(sendData);
        this.setState({ allPluginCount: count, showDataList: [...showDataList] });
    }
}

export default step2detail1